import { QSetStatusTag } from '@exam-management/components';
import { type QSetStatus } from '@exam-management/graphql';
import { EllipsisText, type GridColDef } from '@shared/components';
export interface QuestionUsage {
  id: string;
  qSetCode: string;
  examCode: string;
  examCourse: string;
  qConfigRefId: number;
  questionNumber: number;
  status: QSetStatus;
}

export const columns: GridColDef<QuestionUsage>[] = [
  {
    field: 'qSetCode',
    headerName: 'QSet ID',
    width: 160,
    sortable: false,
    renderCell: (params) => {
      return <EllipsisText>{params.row.qSetCode}</EllipsisText>;
    },
  },
  {
    field: 'examCode',
    headerName: 'Exam Code',
    width: 160,
    sortable: false,
    renderCell: (params) => {
      return <EllipsisText>{params.row.examCode}</EllipsisText>;
    },
  },
  {
    field: 'examCourse',
    headerName: 'Exam Course',
    flex: 1,
    sortable: false,
    renderCell: (params) => {
      return <EllipsisText>{params.row.examCourse}</EllipsisText>;
    },
  },
  {
    field: 'qConfigRefId',
    headerName: 'QConfig Ref.',
    width: 120,
    sortable: false,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => {
      return <EllipsisText>{params.row.qConfigRefId}</EllipsisText>;
    },
  },
  {
    field: 'questionNumber',
    headerName: 'No.',
    width: 60,
    sortable: false,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => {
      return <EllipsisText>{params.row.questionNumber}</EllipsisText>;
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 160,
    sortable: false,
    renderCell: (params) => {
      return <QSetStatusTag status={params.row.status} />;
    },
  },
];
